import { getUpgradeCurrentReplaceValueById } from "@/game/utils/upgrades";
import { FrameName } from "../config";
import { UpgradeIds } from "../config/upgrades";
import ShallowSeaSmallFishTerrainTileEntity from "./ShallowSeaSmallFishTerrainTileEntity";

class DeepSeaMediumFishTerrainTileEntity extends ShallowSeaSmallFishTerrainTileEntity {
	public static readonly frameName = FrameName.DEEP_SEA_MEDIUM_FISH;

	public get exploreCoefficient(): number | null {
		let exploreCoefficient = super.exploreCoefficient || 0;

		exploreCoefficient -= getUpgradeCurrentReplaceValueById(
			UpgradeIds.pirate_navigation,
		);
		return Math.max(exploreCoefficient, 0);
	}
}

export default DeepSeaMediumFishTerrainTileEntity;
